import ProductsFeatures from '../pricing/ProductsFeatures'

const ChooseLicense = ({
  products,
  pricingDurationActive,
  show,
  subscriptionData,
  pageOn,
}) => {
  return (
    <>
      <div
        className="tikbox-order tikbox-container"
        style={{
          display: show ? 'block' : 'none',
          paddingTop: 0,
          paddingBottom: 0,
        }}>
        <h2>
          {subscriptionData?.isUgradeablePlan ? 'Our plans' : 'Choose a plan'}{' '}
        </h2>
      </div>
      <div
        className="tikbox-details tikbox-container"
        style={{ display: show ? 'block' : 'none' }}>
        <ProductsFeatures
          products={products}
          pricingDurationActive={pricingDurationActive}
          show
          pageOn={pageOn}
          subscriptionData={subscriptionData}
        />
      </div>
    </>
  )
}

export default ChooseLicense
